<template>
  <div>
  <v-row >
    <v-col cols="12" >
      <p class="text-h5 font-weight-bold primary--text" ref="otros_aspectos">
        Actividades
      </p>
    </v-col>
    <v-col cols="12">
      <div class=" px-sm-4">
        <TablaTabs
          :headers="headers"
          :data="actividades"
          :por_pagina="paginacion.por_pagina"
          :page="paginacion.pagina"
          :total-registros="paginacion.total_registro"
          :key-id="'id'"
          :slots-column="['activo']"
          :rol="rol"
          @paginationChange="setPaginacion"
          @perPageChange="setPorPagina"
        >
          <template #[`activo`]="{ item }">
            <v-checkbox
              color="primary"
              class="ml-10"
              v-model="item.activo"
              @change="inputChange($event, item)"
              :readonly="!enFaseUnidad || enVistaDetalle"
              :disabled="!enFaseUnidad || enVistaDetalle"
            ></v-checkbox>
          </template>
        </TablaTabs>
      </div>
    </v-col>
  </v-row>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import TablaTabs from "../../../components/TablaTabs.vue";

export default {
  name: "Actividades",
  props: {
    rol: {
      type: String,
      required: true,
      default: () => "unidad",
    },
    idSoli: {
      type: Number,
      default: () => 7,
    },
    isView: {
      type: Boolean,
    },
  },
  data() {
    return {
      actividades: [],
      headers: [
        {
          text: "Mostrar en oferta",
          align: "left",
          value: "activo",
          width: this.$vuetify.breakpoint.smAndDown ? "5%" : "22%",
          class: "black--text py-8 font-weight-bold text-subtitle-1",
          sortable: false,
        },
        {
          text: "N°",
          value: "correlativo",
          align: "left",
          width: this.$vuetify.breakpoint.smAndDown ? "15%" : "5%",
          class: "black--text py-8 font-weight-bold text-subtitle-1",
          sortable: false,
        },
        {
          text: "Descripción de actividad",
          align: "left",
          width: this.$vuetify.breakpoint.smAndDown ? "25%" : "200",
          value: "descripcion",
          class: "black--text py-8 font-weight-bold text-subtitle-1",
          sortable: false,
        },
        // {
        //   text: "Acciones",
        //   value: "accion",
        //   sortable: false,
        //   width: "140",
        //   class: 'black--text py-8 font-weight-bold text-subtitle-1'
        // },
      ],
      paginacion: {
        pagina: 1,
        por_pagina: 10,
        total_registro: 0,
      },
      itemDeleted: null,
    };
  },
  components: { TablaTabs },
  methods: {
    ...mapMutations("utils", ["setLoader"]),
    async getActividades() {
      this.setLoader(true);
      let params = {
        cantidad_por_pagina: this.paginacion.por_pagina,
        pagina: this.paginacion.pagina,
      };
      const { data } = await this.services.catalogos.getCatalogo(
        `actividades/${this.idSoli}`,
        params
      );
      if (Array.isArray(data.data)) {
        this.actividades = data.data.map((x, index) => {
          x.correlativo = index + 1;
          return x;
        });
      } else {
        this.actividades = [];
      }
      this.$nextTick(() => {
        this.paginacion.pagina = Number(data.meta.pagina);
        this.paginacion.por_pagina = Number(data.meta.cantidad_por_pagina);
        this.paginacion.total_registro = Number(data.meta.total);
      });
      for (let i = 0; i < this.actividades.length; i++) {
        this.$set(this.actividades[i], "activo", false);
      }
      this.getActividadesAsignadas();
      this.setLoader(false);
    },
    async getActividadesAsignadas() {
      const response = await this.services.catalogos.getActividadAsig(
        this.$route.params.id
      );
      let idArreglo = response.data;
      for (let i = 0; i < this.actividades.length; i++) {
        const objeto = this.actividades[i];
        if (idArreglo.includes(objeto.id)) {
          this.$set(objeto, "activo", true);
        }
      }
      if (!this.fasesUnidad.includes(this.faseActual)) {
        this.actividades = this.actividades.filter(item => item.activo);
      }
    },
    async inputChange(event, item) {
      this.setLoader(true);
      // Bloquear si está en modo vista o fuera de fases editables
      if (!this.enFaseRRHH && !this.enFaseUnidad) {
        this.setLoader(false);
        return;
      }
      let body = {
        id_solicitud: Number(this.$route.params.id),
        id_catalogo: item.id,
      };
      const response = await this.services.catalogos.postCatalogo(
        "actividades",
        body
      );

      if (response.status === 200 || response.status === 201) {
        this.getActividadesAsignadas();
      }
      this.setLoader(false);
    },
    async setPaginacion(pagina) {
      this.paginacion.pagina = pagina;
      await this.getActividades();
    },
    async setPorPagina(perPage) {
      this.paginacion.por_pagina = perPage;
      this.paginacion.pagina = 1;
      await this.getActividades();
    },
    async init() {
      await this.getActividades();
    },
  },
  computed: {
    ...mapState("solicitud", [
      "solicitud",
      "faseActual",
      "esFaseActivaUsuario",
      "fasesRh",
      "fasesUnidad",
      "faseID",
      "idEstadoFaseActiva",
    ]),
    enFaseRRHH() {
      return this.fasesRh.includes(this.faseActual);
    },
    enFaseUnidad() {
      const cumpleFaseUnidad = this.fasesUnidad.includes(this.faseActual);

      const rutaAprobacion = this.$route.name.includes("aprobacion-solicitud");
      const idObservado = 6;
      const observado = this.solicitud.estado_fase_solicitud.id === idObservado;
      if (observado) {
        return cumpleFaseUnidad && observado && !rutaAprobacion;
      }
      return cumpleFaseUnidad;
    },
    enVistaDetalle() {
      const rutaVer = this.$route.name.includes("solicitud-view");
      return rutaVer;
    },
  },
  async created() {
    await Promise.race([this.init()]);
  },
};
</script>

<style scoped lang="scss"></style>
